<template>
    <div>
        <b-row>
            <b-col cols="7">
                <b-card no-body>
                    <template #header>
                        <strong>
                            SOP Stats
                        </strong>
                    </template>
                    <div class="p-2">
                        <b-input-group  class="green_search mb-3">
                            <b-input-group-prepend>
                                <span class="input-group-text">
                                    <i  class="fas fa-search"></i>
                                </span>                    
                            </b-input-group-prepend>
                            <b-form-input size="sm"></b-form-input>
                        </b-input-group>
                        <webix-ui :config="ui" v-model="stats"></webix-ui>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="5">
                <b-card no-body>
                    <template #header>
                        <strong>
                            Document Details
                        </strong>
                    </template>
                    <div class="p-2" v-if="selected_sop != null">
                        <p>
                            <span style="font-weight: bold;">Current SOP No: </span>
                            <span>{{selected_sop.sop_code}}</span>
                        </p>
                        <p>
                            <span style="font-weight: bold;">Number Of Revisions: </span>
                            <span>N/A</span>
                        </p>
                        <p>
                            <span style="font-weight: bold;">Date Of Distribution: </span>
                            <span>N/A</span>
                        </p>
                    </div>
                    <b-alert class="ms-2 me-2" v-else show>
                        No Document Selected
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// eslint-disable-next-line
import ApexCharts from 'apexcharts'
import _ from 'lodash'
import { sopState, sopMethods } from '@/state/helpers'
export default {
    data:() => ({
        selected_sop: null,
        ui:{
            id: 'statsTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            editable: true,
            columns:[
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"company_name", header:"Company Name", fillspace: true},
                { id:"contact_person", header:"Contact Person", fillspace:0.8},
                { id:"sop_status", header:"Client SOP Status", fillspace:0.6},
                { id:"sop_revision_no", header:"Client SOP Revision", fillspace:0.6},
                { id: "actions", header: "Action", fillspace: 0.5,
                    editor: 'select',
                    options:[
                        { id: 'action', value: 'Action'},
                        { id: 'flag', value: 'Flag'},
                        { id: 'reminder', value: 'Send Reminder'},
                        { id: 'update', value: 'Update SOP'},
                    ]
                }
            ],
            on: {
                onItemClick(id){
                    let el = this.$scope.$parent;
                    var item = this.getItem(id)
                    el.selected_sop = item;

                    let params = {
                        type_id: el.context_menu_id,
                        client_id: item.id,
                    }
                    el.loadClientSop(params)
                },
                onEditorChange(id, value){
                    this.editStop();
                    let el = this.$scope.$parent;
                    switch(value){
                        case 'update':{
                            el.editDocument(id);
                            break;
                        }
                        default:{
                            console.log('Not added yet');
                        }
                    }
                    let item = this.getItem(id);
                    item.actions = 'action';
                    this.updateItem(id, item);
                    this.refresh();
                },
            },
            onClick:{},
        },
    }),
    computed:{
        ...sopState,
        stats(){
            if(this.sop_stats == null){
                return [];
            }
            else{
                let data = _.cloneDeep(this.sop_stats);
                data.forEach( item => {
                    item['actions'] = 'action';
                });
                return data;
            }
        }
    },
    watch:{
        // stats(){
        //     if(this.stats.length > 0){
        //         let table = window.webix.$$('statsTable');
        //         if(table != undefined){
        //             table.select(this.stats[0].id);
        //         }
        //     }
        // }
    },
    methods:{
        ...sopMethods,
        editDocument(id){
            console.log(id);
        }
    },
    mounted(){
        this.loadSopStats({id:this.$route.params.document_id})
        .then(()=>{

        })
        .catch(()=>{

        })
    },
}
</script>

<style>

</style>